import React from 'react';

const ButtonSpinner = ({ size = 'small', color = 'white' }) => {
  const spinnerSize = size === 'small' ? 'w-4 h-4 border-2' : 'w-6 h-6 border-4';
  const spinnerColor = color === 'white' ? 'border-white border-t-transparent' : 'border-blue-500 border-t-transparent';

  return (
    <div className={`${spinnerSize} ${spinnerColor} rounded-full animate-spin`}></div>
  );
};

export default ButtonSpinner;
